import GamepageTemplate from "../components/containers/GamepageTemplate";

const BurninRubber3A = () =>{
    return(
        <GamepageTemplate 
            backgroundPng={"3a"}
            gameTitle={"Burnin' Rubber 3A"}
            gameDescription={"Dominate once again the world in this expanded version of Burnin' Rubber 3"}
            embedYouTubeId={"mEWDQT-C0NA?si=VmY4-PZI2lftkSDl"}
            downloadPath={"https://www.mediafire.com/file/nkiaqt7ut6k5ojk/Burnin%2527_Rubber_3A_%2528By_Mars%2529.rar/file"}
            gameVersion={"1.0"}
            versionDate={"2023-03"}
            endOfSupportDate={"2024-06-02"}
        />  
    );
};

export default BurninRubber3A;
